import { render, staticRenderFns } from "./Realgrid.vue?vue&type=template&id=2f471ec4&"
import script from "./Realgrid.vue?vue&type=script&lang=js&"
export * from "./Realgrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports